import React from "react";
import { observer } from "mobx-react-lite";

import styles from "./numberedList.module.css";

export const NumberedList: React.FC<{ items: string[] | React.ReactNode[] }> = observer(({ items }) => {
  return (
    <ol className={styles.numberedList}>
      {items.map((item, index) => (
        <li key={index} className={styles.numberedItem}>
          {item}
        </li>
      ))}
    </ol>
  );
});
